import { render, staticRenderFns } from "./MonitorPermissionManage.vue?vue&type=template&id=6a04d63b&"
import script from "./MonitorPermissionManage.vue?vue&type=script&lang=js&"
export * from "./MonitorPermissionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports